<template>
  <div class="loading-quote text-center">
    <h2 class="px-2">{{ $t('message.insurance.loadingScreen.heading') }}</h2>
    <p class="mt-5">{{ $t(`message.insurance.loadingScreen.step${currentStep}`) }}</p>
    <div class="car-race">
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          :style="{ width: percentDone + '%' }"
          :aria-valuenow="percentDone"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <div class="flag">
        <img src="@/assets/chequered-flag.svg" />
      </div>
      <div class="car-container">
        <img
          :style="{ left: percentDone + '%', marginLeft: (-30 * percentDone) / 100 + 'px' }"
          src="@/assets/automobile.svg"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingQuote',
  data() {
    return {
      currentStep: 1,
      numberOfSteps: 4,
      animationComplete: false,
    };
  },
  props: {
    // Total loading time estimate
    loadingTime: {
      type: Number,
      default: 30,
    },
    // Set to true when ready to complete the animation
    loadingComplete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    stepTime() {
      return this.loadingTime / this.numberOfSteps;
    },
    percentDone() {
      return ((this.currentStep - 1) / (this.numberOfSteps - 1)) * 100;
    },
  },
  mounted() {
    this.incrementStep();
  },
  watch: {
    loadingComplete() {
      this.completeLoadingAnimation();
    },
    animationComplete() {
      this.$emit('loadingAnimationIsComplete');
    },
  },
  methods: {
    // Go step by step based on the step time, don't go the end yet though
    incrementStep() {
      setTimeout(() => {
        if (this.currentStep !== this.numberOfSteps - 1 && this.loadingComplete !== true) {
          this.currentStep += 1;
          this.incrementStep();
        }
      }, this.stepTime * 1000);
    },
    // Once loading is ready to be completed, complete all remaining steps quickly!
    completeLoadingAnimation() {
      setTimeout(() => {
        if (this.currentStep !== this.numberOfSteps) {
          this.currentStep += 1;
          this.completeLoadingAnimation();
        } else {
          this.animationComplete = true;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';

.loading-quote {
  max-width: 550px;
  margin: 133px auto;
}
p {
  font-weight: bold;
  color: $primary;
  margin-bottom: 32px;
}
.car-race {
  position: relative;
  text-align: left;
  .car-container {
    position: relative;
    margin-right: 25px;
    img {
      transition: all 800ms ease;
      position: absolute;
      top: -17px;
    }
  }
  .flag {
    right: 0;
    position: absolute;
    top: -11px;
  }
}
.progress {
  background: #dae2ea;
  border-radius: 8px;
  height: 4px;
  margin-right: 25px;
}
.progress-bar {
  background: $primary;
  transition: width 800ms ease;
}
</style>
